import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-discipline-list" }
const _hoisted_2 = { class: "d-flex justify-content-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_5 = { class: "pt-4 pb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StaffRoleModal = _resolveComponent("StaffRoleModal")!
  const _component_DeleteEntityModal = _resolveComponent("DeleteEntityModal")!
  const _component_MrUiKitButton = _resolveComponent("MrUiKitButton")!
  const _component_MrUiKitTable = _resolveComponent("MrUiKitTable")!
  const _component_MrUiKitPagination = _resolveComponent("MrUiKitPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_StaffRoleModal, {
          key: 0,
          value: _ctx.selectedStaffRole,
          onClose: _ctx.onCloseModal
        }, null, 8, ["value", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteModal === true && _ctx.selectedStaffRole)
      ? (_openBlock(), _createBlock(_component_DeleteEntityModal, {
          key: 1,
          name: _ctx.selectedStaffRole.name,
          onSubmit: _ctx.onSubmitDelete,
          onClose: _ctx.onCloseDelete
        }, null, 8, ["name", "onSubmit", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_MrUiKitTable, {
      rows: _ctx.disciplines,
      columns: _ctx.columns,
      search: true,
      searchLabel: _ctx.searchLabel,
      onSearch: _ctx.onSearch
    }, {
      name: _withCtx(({item}) => [
        _createTextVNode(_toDisplayString(item.name), 1)
      ]),
      action: _withCtx(({item}) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_MrUiKitButton, {
            classes: ['btn-icon btn-primary-outline btn-sm'],
            onClick: ($event: any) => (_ctx.onUpdate(item))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_MrUiKitButton, {
            classes: ['btn-icon btn-primary-outline btn-sm'],
            onClick: ($event: any) => (_ctx.onDelete(item))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["rows", "columns", "searchLabel", "onSearch"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_MrUiKitPagination, {
        modelValue: _ctx.pagination,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
        onLoad: _ctx.onLoad
      }, {
        default: _withCtx((slotProps) => [
          _createTextVNode(_toDisplayString(_ctx.t('pagination.page')) + " " + _toDisplayString(_ctx.pagination.current) + " " + _toDisplayString(_ctx.t('pagination.of')) + " " + _toDisplayString(slotProps.lastPage), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "onLoad"])
    ])
  ]))
}